import { render, staticRenderFns } from "./ColorsMapsAddModal.vue?vue&type=template&id=dc036a8e&scoped=true&"
import script from "./ColorsMapsAddModal.vue?vue&type=script&lang=js&"
export * from "./ColorsMapsAddModal.vue?vue&type=script&lang=js&"
import style0 from "./ColorsMapsAddModal.vue?vue&type=style&index=0&id=dc036a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc036a8e",
  null
  
)

export default component.exports